// `scrollIntoView` has no container-scoped mode — it walks up and scrolls every
// ancestor, cancelling any smooth scroll already in flight on the page. Moving
// the box's own scrollTop by how far the item sticks out keeps it local.
export const revealInScrollBox = (box, item) => {
    const boxRect = box.getBoundingClientRect();
    const itemRect = item.getBoundingClientRect();
    box.scrollTop +=
        Math.min(0, itemRect.top - boxRect.top) +
            Math.max(0, itemRect.bottom - boxRect.bottom);
};
